import { AxiosRequest } from 'src/lib/axios/Axios';

export const PUBLICATION_MARKETPLACE = 'pipestore';

export interface CampaignCatalogItem {
  campaign_id: number;
  name: string;
  campaign_state_id: number;
}

export interface TargetCatalogItem {
  target_id: number;
  name: string;
}

export interface ProductCatalogItem {
  product_id: number;
  sku: string;
  categories: string[];
  name: string;
}

export interface ZoneCatalogItem {
  zone_id: string;
  name: string;
}

export const fetchCampaigns = async (
  marketplace = PUBLICATION_MARKETPLACE,
): Promise<CampaignCatalogItem[]> => {
  const { data } = await AxiosRequest.get<CampaignCatalogItem[]>('/campaigns', {
    params: { marketplace },
  });
  return data ?? [];
};

export const fetchTargets = async (
  campaignIds: number[],
  marketplace = PUBLICATION_MARKETPLACE,
): Promise<TargetCatalogItem[]> => {
  if (!campaignIds.length) return [];
  const { data } = await AxiosRequest.get<TargetCatalogItem[]>('/targets', {
    params: {
      marketplace,
      campaignIds: campaignIds.join(','),
    },
  });
  return data ?? [];
};

export const fetchProducts = async (
  marketplace = PUBLICATION_MARKETPLACE,
): Promise<ProductCatalogItem[]> => {
  const { data } = await AxiosRequest.get<ProductCatalogItem[]>('/products', {
    params: { marketplace },
  });
  return data ?? [];
};

export const fetchZones = async (
  marketplace = PUBLICATION_MARKETPLACE,
): Promise<ZoneCatalogItem[]> => {
  const { data } = await AxiosRequest.get<ZoneCatalogItem[]>('/zones', {
    params: { marketplace },
  });
  return data ?? [];
};
